import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-log`

let api = {
  // 获取操作日志数据
  getLogPage: `${baseUrl}/log/getPage`,

  // 导出操作记录
  exportLog: `${baseUrl}/log/export`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/common.js